import { render } from "./ListOfFilesView.vue?vue&type=template&id=d2b6907a&scoped=true"
import script from "./ListOfFilesView.vue?vue&type=script&lang=js"
export * from "./ListOfFilesView.vue?vue&type=script&lang=js"

import "./ListOfFilesView.vue?vue&type=style&index=0&id=d2b6907a&lang=scss&scoped=true"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2b6907a"]])

export default __exports__